import { Empty } from 'antd';
import { Box } from '@mui/material';

const EmptyUI = ({ name }) => {
	return (
		<Empty
			style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
			description={<Box variant="span">No {name}</Box>}
		></Empty>
	);
};

export default EmptyUI;
